import {
  Component
} from '@angular/core';

import {
  CommonModule
} from '@angular/common';

import {
  ReactiveFormsModule
} from '@angular/forms';

import {
  MatInputModule
} from '@angular/material/input';

import { LineCellBaseComponent }
from '../line-cell-base/line-cell-base.component';

@Component({
  selector: 'app-line-cell-number',

  standalone: true,

  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule
  ],

  templateUrl:
    './line-cell-number.component.html'
})
export class LineCellNumberComponent
extends LineCellBaseComponent {
}